<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--dark layout--padding-bottom-xl"
  >
    <div class="layout__component-container layout__component-container--dark">
      <h2 class="text-size-xl weight--bold layout--margin-bottom-xs">
        Change Your Plan
      </h2>
      <router-link
        :to="{ name: getBackInfo.routeName }"
        class="link account__back-link"
        ><IconArrowBack class="icon layout--margin-right-xs" />{{
          getBackInfo.text
        }}</router-link
      >
      <div class="account__main-content">
        <router-view @update:change-summary="setChangeSummary"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronIcon from "../../assets/icons/icon-chevron.svg";
import IconArrowBack from "../../assets/icons/iconArrowBack.svg";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "ChangePlan",
  components: {
    ChevronIcon,
    IconArrowBack,
  },
  data() {
    return {
      changeSummary: null,
    };
  },
  computed: {
    ...mapGetters("account", ["data"]),
    getBackInfo() {
      const { name } = this.$route;
      const isFreePlan = this.changeSummary && this.changeSummary.newPlanLabel === "Free";

      if (name === "choose billing period" || isFreePlan) {
        return {
          text: "Back to Plans",
          routeName: "change plan",
        };
      }
      if (name === "summary") {
        return {
          text: "Back to Choose Billing Period",
          routeName: "choose billing period",
        };
      }
      return {
        text: "Back to My Account",
        routeName: "account",
      };
    },
  },
  methods: {
    setChangeSummary(changeSummary) {
      this.changeSummary = changeSummary;
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/pages/_changeAccount.scss";
</style>
